module.exports = __webpack_public_path__ + "static/img/bodyImg3.28260ad8.png";